import Activity from '@/models/_deprecated/Activity';
import { QuizActivityElement } from '@/models/_deprecated/ActivityElement';
import { QuizRaw } from '../model/quiz';

export type ActivityQuiz = Omit<Activity, 'questions'> & {
  questions: QuizActivityElement[];
};

export const adapterActivityTool = (activity: ActivityQuiz): QuizRaw => {
  const quiz = activity.questions[0];
  const alternatives = quiz.quizAnswers || quiz.quizQuestions;

  return {
    title: quiz.question,
    content: quiz.content,
    alternatives:
      alternatives?.map((question, index) => ({
        id: question.id ?? index,
        answer: (question.answer as string) ?? '',
        index,
        status: 'empty',
        verifier: question.answerVerifier ?? '',
      })) ?? [],
    id: quiz.id,
    activityId: activity.id,
    done: activity.isDone,
  };
};
